import type { ReactNode } from 'react';
import { IconApps, IconDashboard, IconFile, IconLeft, IconNotification } from '../components/icons';
import { tabForRoute, type MobileRoute, type MobileTabPath } from '../app/navigation';
import MobileBottomNav from '../components/MobileBottomNav';
import MobileApplicationSwitcher from '../components/MobileApplicationSwitcher';
import type { MobileBusinessApp, ShellMode } from '../types';

type Props = {
  route: MobileRoute;
  title: string;
  avatarName: string;
  mode: ShellMode;
  noticeCount: number;
  children: ReactNode;
  onNavigate: (path: string) => void;
  onCloseBusiness: () => void;
  apps: MobileBusinessApp[];
  embeddedApp: boolean;
  switcherOpen: boolean;
  onSwitcherOpen: () => void;
  onSwitcherClose: () => void;
  onSwitchApp: (code: string) => void;
};

function MobileShellView(props: Props) {
  const business = props.route.kind === 'business';
  const taskDetail = props.route.kind === 'task-detail';
  const showBottomNav = !taskDetail && !props.embeddedApp && (!business || props.mode === 'persistent');
  const platformCount = 0;
  return <div className={`mobile-prototype${business ? ' mobile-prototype--business' : ''}`}>
    {props.embeddedApp ? <header className="mobile-embedded-header" aria-label="中台应用顶部栏">
      <h1 className="mobile-embedded-header__title">{props.title}</h1>
      <nav className="mobile-embedded-header__controls" aria-label="嵌入应用平台操作">
        <button type="button" aria-label={`打开平台任务与通知，${platformCount} 项待查看`} title="平台入口" onClick={() => props.onNavigate('/portal/workbench')}><IconDashboard />{platformCount ? <span className="mobile-embedded-header__badge" aria-hidden="true" /> : null}</button>
        <button type="button" aria-label="切换应用" title="切换应用" onClick={props.onSwitcherOpen}><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.7"><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></svg></button>
      </nav>
    </header> : !taskDetail ? <header className="mobile-prototype__header">
      {business ? <button className="mobile-header-back" type="button" onClick={props.onCloseBusiness}><IconLeft /><span>关闭</span></button> : <button className="mobile-prototype__avatar" type="button" aria-label={props.avatarName} title={props.avatarName} disabled>{props.avatarName.slice(0, 1)}</button>}
      <h1>{props.title}</h1>
      {business ? <button className="mobile-header-action" type="button" onClick={() => props.onNavigate('/portal/workbench')}><IconApps /><span>平台</span></button> : <div className="mobile-prototype__header-actions">
        {props.route.kind === 'tasks' ? <button className="mobile-header-action" type="button" aria-label="打开草稿箱" title="草稿箱" onClick={() => props.onNavigate('/portal/drafts')}><IconFile /></button> : null}
        <button className="mobile-header-action" type="button" aria-label="通知暂未开放" disabled><IconNotification />{props.noticeCount ? <i /> : null}</button>
      </div>}
    </header> : null}
    <main className="mobile-prototype__content" aria-label={`${props.title}内容`} key={props.route.kind === 'business' ? props.route.appCode : props.route.kind}>{props.children}</main>
    {business && !props.embeddedApp && props.mode === 'immersive' ? <button className="mobile-platform-capsule" type="button" onClick={() => props.onNavigate('/portal/workbench')}><IconApps /><strong>平台</strong><span>任务 · 通知</span></button> : null}
    {showBottomNav ? <MobileBottomNav activePath={tabForRoute(props.route)} onNavigate={(path: MobileTabPath) => props.onNavigate(path)} /> : null}
    <MobileApplicationSwitcher open={props.switcherOpen} apps={props.apps} currentCode={props.route.kind === 'business' ? props.route.appCode : ''} onClose={props.onSwitcherClose} onSelect={props.onSwitchApp} />
  </div>;
}

export default MobileShellView;
